import { Props } from './props';
import { Dialog } from '../../../../../components/general/dialog/dialog';
import { useModalCreate } from './hook';
import { Box, Grid, Typography } from '@mui/material';

export const ModalCreate = ({ open, title, consecutiveFormat }: Props) => {
    const { handleClose } = useModalCreate();

    return (
        <Dialog title={title} open={open} onClose={handleClose}>
            <Grid
                container
                item
                xs={12}
                direction="column"
                alignItems="center"
                justifyContent="center"
            >
                <Box
                    style={{
                        maxWidth: '500px',
                        textAlign: 'center',
                        padding: '16px',
                    }}
                >
                    <Typography variant="h5">
                        Su PQR fue radicada satisfactoriamente con el N°{' '}
                        {consecutiveFormat}, por favor tenga en cuenta este
                        número para realizar consultas en nuestra página web.
                        Gracias por contactarnos, puede cerrar esta pestaña.
                    </Typography>
                </Box>
            </Grid>
        </Dialog>
    );
};
